import * as React from 'react'
// components
import { Link, Table } from 'components/UI'
import TableRow from '@mui/material/TableRow'
import Chip from '@mui/material/Chip'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
import { UsersPageContext } from 'containers/Users/layers/API'
// constants
import { COUNTRIES } from 'constants/countries'
import { DATE_FORMATS } from 'constants/date'
// views
import { TableCell } from 'themes/views/tables'

const headers = [
  { id: 'user.name', sortable: false, left: true, label: 'NAME' },
  { id: 'user.phone', sortable: false, left: true, label: 'PHONE' },
  { id: 'user.dateOfBirth', sortable: false, left: true, label: 'DATE OF BIRTH' },
  { id: 'user.email', sortable: true, left: true, label: 'EMAIL' },
  { id: 'user.active', sortable: true, left: true, label: 'ACTIVE' },
]

const UsersTable: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, totalCount, refetch, isRefetching } = React.useContext(UsersPageContext)

  return (
    <Table
      data={data}
      page={page}
      title='Users'
      perPage={perPage}
      refetch={refetch}
      headers={headers}
      totalCount={totalCount}
      isLoading={isRefetching}
      onPageChange={handleSetPage}
      onPerPageChange={handleSetPerPage}>
      {({ data }) =>
        data.map(({ id, companyId, firstName, lastName, displayName, mobilePhone, dateOfBirth, email, active }) => (
          <TableRow key={id} hover data-testid='user-row' data-entity-id={id}>
            <TableCell size={35}>
              <Link href={`/settings/users/${id}?companyId=${companyId}`}>
                {displayName || `${firstName} ${lastName}`}
              </Link>
            </TableCell>
            <TableCell size={25}>{mobilePhone || 'N/A'}</TableCell>
            <TableCell size={15}>
              {dateOfBirth ? DATE_FORMATS()[COUNTRIES.AU].format(new Date(dateOfBirth)) : 'N/A'}
            </TableCell>
            <TableCell size={25}>{email}</TableCell>
            <TableCell size={25}>
              <Chip
                size='small'
                label={active ? 'Active' : 'Inactive'}
                color={active ? 'success' : 'default'}
              />
            </TableCell>
          </TableRow>
        ))
      }
    </Table>
  )
}

export default UsersTable
